export const PaymentEndpoint = {
    GetPayments: `${process.env.API_BACKEND}/v1/payments/payment/`,
    CreateCashPayment: `${process.env.API_BACKEND}/v1/payments/payment/cash`,
    CreateCertificatePayment: `${process.env.API_BACKEND}/v1/payments/payment/certificate`,
    CreateOnlineCloudPayment: `${process.env.API_BACKEND}/v1/payments/payment/online/cloudpayments`,
    CreateOnlineYookassaPayment: `${process.env.API_BACKEND}/v1/payments/payment/online/yookassa`,
    CreateAccountPayment: `${process.env.API_BACKEND}/v1/payments/payment/account`,
    ConfirmAccountPayment: `${process.env.API_BACKEND}/v1/payments/payment/account/confirm`,
    GetPaymentsByOrderId: `${process.env.API_BACKEND}/v1/payments/payment/order/`,
    GetPaymentMethods: `${process.env.API_BACKEND}/v1/payments/payment/methods`,
    RefundPayment: (order_id: number) =>
        `${process.env.API_BACKEND}/v1/payments/payment/order/${order_id}/refund`,
    CancelPayments: (paymentId: number) =>
        `${process.env.API_BACKEND}/v1/payments/payment/${paymentId}/cancel`,
}
